export { default } from './SideImage';
